import { createContext, useReducer } from "react";
const currentYear = new Date().getFullYear();
const initialState = {
  megaMenu: {
    nav: [],
    columns: null,
    currentMenu: null,
  },
  hamburgerMenu: {
    nav: [],
    buttons: [],
    isOpen: false,
    currentMenu: null,
  },
  footerMenu: {
    logo: {},
    contactInfo: {},
    contactInfoLinks: {},
    socialLinks: [],
    mainLinks: [],
    miscLinks: [],
    ctas: [],
    copyright: {
      year: `© ${currentYear}`,
      website: {
        label: "Rollins College",
        url: "https://www.rollins.edu/",
      },
      links: [
        {
          label: "Privacy Policy",
          target: "_blank",
          url: "https://www.rollins.edu/the-fine-print/privacy-policy",
        },
      ],
    },
  },
  section: "test",
};

const reducer = (state, { type, data }) => {
  switch (type) {
    case "UPDATE_GLOBAL_STATE":
      return { ...state, ...data };
    case "UPDATE_MEGA_MENU":
      return { ...state, megaMenu: { ...state.megaMenu, ...data } };
    case "UPDATE_HAMBURGER_MENU":
      return { ...state, hamburgerMenu: { ...state.hamburgerMenu, ...data } };
    default:
      throw new Error();
  }
};
const StateContext = createContext(initialState);

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StateContext.Provider value={[state, dispatch]}>
      {children}
    </StateContext.Provider>
  );
};

const menuReducer = (state, { type, data }) => {
  // switch (type) {
  //   case "UPDATE_GLOBAL_STATE":
  //     return { ...state, ...data };
  //   case "UPDATE_MEGA_MENU":
  //     return { ...state, megaMenu: { ...state.megaMenu, ...data } };
  //   case "UPDATE_HAMBURGER_MENU":
  //     return { ...state, hamburgerMenu: { ...state.hamburgerMenu, ...data } };
  //   default:
  //     throw new Error();
  // }
};

const MenuContext = createContext(null);
const MenuProvider = ({ children, menus }) => {
  const megaMenuRaw = menus?.find(({ type }) => type === "mega") || [];
  const miscMenuRaw = menus?.find(({ type }) => type === "misc") || [];
  const ctaMenuRaw = menus?.find(({ type }) => type === "cta") || [];
  const isHamburgerOnly = !!megaMenuRaw?.isHamburgerOnly;

  // Mega Menu Data
  const megaMenu =
    megaMenuRaw?.items?.map((item) => {
      const url = (item?.externalLink || item?.internalLink)?.replace(
        "https://www.rollins.edu",
        ""
      );

      return {
        label: item?.label,
        startsWith: url || "#",
        url,
        columns:
          item?.menuItems
            ?.filter(({ menuItems }) => menuItems?.length)
            ?.map((column) => {
              return column?.menuItems?.map((subItem, index) => {
                const prevSubItem = column?.menuItems[index - 1];
                const nextSubItem = column?.menuItems[index + 1];
                const hasDarkBefore = prevSubItem?.background === "dark";
                const hasInlineBefore = prevSubItem?.layout === "inline";
                const hasDark = subItem?.background === "dark";
                const hasInline = subItem?.layout === "inline";
                const hasButton = subItem?.layout === "button";
                // const buttonVariant =  'PRIMARY_SOLID' || "PRIMARY_OUTLINE" || "SECONDARY_SOLID" || "SECONDARY_OUTLINE" || "TERTIARY_SOLID" || "TERTIARY_OUTLINE";


                const hasDarkAfter = nextSubItem?.background === "dark";
                const hasInlineAfter = nextSubItem?.layout === "inline";
                const subItemUrl = (
                  subItem?.externalLink ||
                  subItem?.internalLink ||
                  subItem?.callToActionLink
                )?.replace("https://www.rollins.edu", "");

                return {
                  hasDark,
                  hasInline,
                  hasButton,
                  url: subItemUrl,
                  label: subItem?.label,
                  icon: subItem?.icon,
                  image: subItem?.image,
                  description: subItem?.body,
                  size: subItem?.textSize,
                  darkStart: hasDark && !hasDarkBefore,
                  darkEnd: hasDark && !hasDarkAfter,
                  inlineStart: hasInline && !hasInlineBefore,
                  inlineEnd: hasInline && !hasInlineAfter,
                };
              });
            }) ?? [],
      };
    }) ?? [];

  // Misc Menu Data
  const miscMenu =
    miscMenuRaw?.items?.map((item) => {
      return {
        label: item?.label,
        items:
          item?.menuItems?.map((subItem) => {
            const subItemUrl = (
              subItem?.externalLink || subItem?.internalLink
            )?.replace("https://www.rollins.edu", "");
            return {
              label: subItem?.label,
              url: subItemUrl,
            };
          }) ?? [],
      };
    }) ?? [];

  // CTA Menu Data
  const ctaMenu =
    ctaMenuRaw?.items?.map((item) => {
      const url = (item?.externalLink || item?.internalLink)?.replace(
        "https://www.rollins.edu",
        ""
      );
      return {
        label: item?.label,
        url,
      };
    }) ?? [];

  const [state, dispatch] = useReducer(reducer, {
    isHamburgerOnly,
    megaMenu,
    miscMenu,
    ctaMenu,
  });

  return (
    <MenuContext.Provider value={[state, dispatch]}>
      {children}
    </MenuContext.Provider>
  );
};

export { StateContext, StateProvider, MenuContext, MenuProvider };
